import _ from "lodash";
import update from "immutability-helper";
import { FEED_TYPE } from "./Utils";
import client from "lib/apolloClient/client";
import {
  bookmarkCourseMutation,
  bookmarkClassMutation,
} from "./LearningCoursesListMutations";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import {
  writeCourseBookmarkStatusInCache,
  writeClassBookmarkStatusInCache,
} from "./LearningCoursesListGraphqlHelpers";

export const NAME = "learningCoursesList";
const SET_ACTIVE_TAB = `SET_ACTIVE_TAB ${NAME}`;
const SET_ENABLED_COLUMNS_DATA = `SET_ENABLED_COLUMNS_DATA ${NAME}`;
const SET_FILTERS = `SET_FILTERS ${NAME}`;
const RESET_REDUX_STATE = `RESET_REDUX_STATE ${NAME}`;
const SET_IS_FILTERS_INITIALIZED = `SET_IS_FILTERS_INITIALIZED ${NAME}`;

export const updateCourseBookmark = ({ courseId, isBookmarked }) => {
  return async dispatch => {
    const input = isBookmarked
      ? { removedLearningCourseIds: [courseId] }
      : { addedLearningCourseIds: [courseId] };

    try {
      await client.mutate({
        mutation: bookmarkCourseMutation,
        variables: { input },
        optimisticResponse: {
          __typename: "Mutation",
          planner: {
            __typename: "PlannerMutations",
            bookmarkLearningCourse: true,
          },
        },
        update(
          cache,
          {
            data: {
              planner: { bookmarkLearningCourse },
            },
          }
        ) {
          if (bookmarkLearningCourse) {
            writeCourseBookmarkStatusInCache({
              id: courseId,
              isBookmarked: !isBookmarked,
            });
          }
        },
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const updateClassBookmark = ({ classId, isBookmark }) => {
  return async dispatch => {
    const input = isBookmark
      ? { removeCourseIds: [classId] }
      : { addCourseIds: [classId] };

    try {
      await client.mutate({
        mutation: bookmarkClassMutation,
        variables: { input },
        optimisticResponse: {
          __typename: "Mutation",
          platform: {
            __typename: "PlatformMutations",
            updateCourseAsBookmark: true,
          },
        },
        update(
          cache,
          {
            data: {
              platform: { updateCourseAsBookmark },
            },
          }
        ) {
          if (updateCourseAsBookmark) {
            writeClassBookmarkStatusInCache({
              id: classId,
              isBookmark: !isBookmark,
            });
          }
        },
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

// Pure functions
export const setActiveTab = tab => {
  return {
    type: SET_ACTIVE_TAB,
    tab,
  };
};

export const setEnabledColumnsData = enabledColumnsData => {
  return {
    type: SET_ENABLED_COLUMNS_DATA,
    enabledColumnsData,
  };
};

export const setFilters = data => {
  return {
    type: SET_FILTERS,
    data,
  };
};

export const resetReduxState = () => {
  return {
    type: RESET_REDUX_STATE,
  };
};

export const setIsFiltersInitialized = data => {
  return {
    type: SET_IS_FILTERS_INITIALIZED,
    data,
  };
};

const REDUCER_HANDLERS = {
  [SET_ACTIVE_TAB]: (state, action) => {
    const { tab } = action;
    return update(state, {
      activeTab: { $set: tab },
    });
  },

  [SET_ENABLED_COLUMNS_DATA]: (state, action) => {
    const { enabledColumnsData } = action;

    return update(state, {
      enabledColumns: { $set: enabledColumnsData },
    });
  },

  [SET_FILTERS]: (state, action) => {
    const params = action.data;
    _.map(Object.keys(params), key => {
      state = update(state, {
        filters: { [key]: { $set: params[key] } },
      });
    });

    return state;
  },

  [RESET_REDUX_STATE]: state => {
    return update(state, {
      $set: initialState,
    });
  },

  [SET_IS_FILTERS_INITIALIZED]: (state, action) => {
    const { data } = action;
    return update(state, {
      isFiltersInitialized: { $set: data },
    });
  },
};

const initialState = {
  activeTab: FEED_TYPE.COURSE,
  enabledColumns: [],
  filters: {
    searchText: "",
    grades: [],
    subjects: [],
    terms: [],
    status: ["ACTIVE"],
    courses: [],
    classes: [],
    departments: [],
    orderBy: "TITLE",
    orderByDirection: "ASC",
    courseView: "MY_COURSES",
  },
  isFiltersInitialized: false,
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
